import { Link } from "react-router-dom";
import { BookButton } from "./Cta";

const links = [
  { href: "/#method", label: "The method" },
  { href: "/#why-luke", label: "Why Luke" },
  { href: "/#first-walk", label: "First Walk" },
];

export const Nav = () => (
  <header
    className="fixed top-0 inset-x-0 z-50 bg-paper/85 backdrop-blur-md border-b border-ink/5"
    data-testid="site-nav"
  >
    <div className="mx-auto max-w-6xl px-5 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
      <Link
        to="/"
        data-testid="nav-wordmark"
        className="font-serif text-lg md:text-xl tracking-tight text-ink"
      >
        Walk It Through
      </Link>
      <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            className="text-sm text-ink/60 hover:text-ink transition-colors duration-300"
          >
            {l.label}
          </a>
        ))}
      </nav>
      <BookButton
        label="Book a First Walk"
        testid="nav-book-cta"
        className="!px-5 !py-2.5 text-sm"
      />
    </div>
  </header>
);
